import { render } from "../views/modal.html?vue&type=template&id=d154728a&ts=true&external"
import script from "../scripts/modal.ts?vue&type=script&lang=ts&external"
export * from "../scripts/modal.ts?vue&type=script&lang=ts&external"

import "../css_builds/components/modal.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d154728a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d154728a', __exports__)) {
    api.reload('d154728a', __exports__)
  }
  
  module.hot.accept("../views/modal.html?vue&type=template&id=d154728a&ts=true&external", () => {
    api.rerender('d154728a', render)
  })

}


export default __exports__